import React, { useState } from "react";
import ReactTooltip from "react-tooltip";
import "./info-bulle.scss";

// Compteur module : garantit des ids de tooltip uniques quand l'info-bulle
// apparaît plusieurs fois à l'écran (une par ligne d'un tableau, par exemple).
let nbInstances = 0;

/**
 * Icône d'information dont le texte s'affiche au survol, à la place d'un texte
 * d'aide affiché en permanence sous un élément.
 *
 * - texte : le contenu de la bulle, repris en aria-label pour les lecteurs d'écran
 * - icone : classe Font Awesome (« fa-info-circle » par défaut)
 * - className : couleur de l'icône (« text-info » par défaut)
 */
const InfoBulle = ({
  texte,
  icone = "fa-info-circle",
  className = "text-info",
  place = "top",
}) => {
  const [tooltipId] = useState(() => `info-bulle-${++nbInstances}`);

  return (
    <>
      <i
        className={`fa ${icone} ${className}`}
        style={{ cursor: "help" }}
        // Atteignable au clavier : le texte s'affiche aussi au focus, et les
        // lecteurs d'écran lisent le libellé.
        tabIndex={0}
        role="img"
        aria-label={texte}
        data-tip={texte}
        data-for={tooltipId}
        data-event="mouseenter focus"
        data-event-off="mouseleave blur"
      />
      <ReactTooltip
        id={tooltipId}
        place={place}
        effect="solid"
        className="info-bulle"
      />
    </>
  );
};

export default InfoBulle;
